import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
    options: {
      maxLength: 50,
    }
  },
  {
    key: 'link',
    label: 'Link',
    type: types.OBJECT,
    children:[
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'margin',
    label: 'Margin',
    type: types.OBJECT,
    children:[
      {
        key: 'left',
        label: 'Margin Left',
        type: types.TEXT,
      },
      {
        key: 'right',
        label: 'Margin Right',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'features',
    label: 'Features',
    type: types.ARRAY,
    options: {
      maxLength: 4,
    },
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
        options: {
          maxLength: 20,
        }
      },
      {
        key: 'shortText',
        label: 'Text for small screen',
        type: types.TEXT,
        options: {
          maxLength: 20,
        }
      },
      {
        key: 'subheading',
        label: 'Sub-Heading',
        type: types.TEXT,
        options: {
          maxLength: 20,
        }
      }
    ]
  }
];

const defaultProps = {
  title: 'First ieVehicle',
  link: {
    text: 'Learn More',
    url: 'https://www.ff.com',
  },
  margin: {
    left: '65px',
    right: '100px',
  },
  features:[
    {
      text: '1050 hp',
      subheading: 'Tri Motor'
    },
    {
      text: '0-60 mph',
      subheading: '2.xx Seconds'
    },
    {
      text: 'Over 300 miles',
      shortText: '300 mi',
      subheading: 'Range(EPA)'
    },
    {
      text: '100+ in',
      subheading: '11 Displays',
    },
  ]
}

export default {
  title: 'Feature List',
  id: 'FeatureList',
  propsSchema,
  defaultProps,
};